const SAFE_TRACKING_KEYS = new Set([
  'form_id',
  'form_type',
  'source_page',
  'source_component',
  'route',
  'language',
  'course_id',
  'course_slug',
  'request_type',
  'status',
  'contact_type',
  'package_type',
  'currency',
  'quoted_price',
  'verified_submission',
]);

const FORBIDDEN_TRACKING_KEYS = new Set([
  'name',
  'full_name',
  'first_name',
  'last_name',
  'email',
  'work_email',
  'phone',
  'mobile',
  'mobile_number',
  'country_code',
  'company_name',
  'contact_person',
  'subject',
  'message',
  'notes',
  'training_goals',
  'password',
  'token',
  'auth_token',
  'user',
  'user_id',
  'uid',
]);

function isSafeScalar(value) {
  return ['string', 'number', 'boolean'].includes(typeof value);
}

function sanitizePayload(payload) {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return {};
  }

  return Object.entries(payload).reduce((sanitized, [key, value]) => {
    if (!SAFE_TRACKING_KEYS.has(key) || FORBIDDEN_TRACKING_KEYS.has(key)) {
      return sanitized;
    }

    if (value === undefined || value === null || !isSafeScalar(value)) {
      return sanitized;
    }

    sanitized[key] = value;
    return sanitized;
  }, {});
}

export function trackEvent(eventName, payload = {}) {
  try {
    if (!eventName || typeof eventName !== 'string') {
      return false;
    }

    if (typeof window === 'undefined' || !Array.isArray(window.dataLayer)) {
      return false;
    }

    window.dataLayer.push({
      event: eventName,
      ...sanitizePayload(payload),
    });

    return true;
  } catch {
    return false;
  }
}
